<template>
    <div>
        <!-- 页面固定头部 -->
        <a-anchor :getContainer="getModuleContainer" style="width:100%">
            <!-- 面包屑组件 -->
            <FGBreadHead></FGBreadHead>
            <!-- //文本搜索内容 -->
            <div class="fun-panel fun-search-form-wrapper">
                <a-form :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
                    <a-row :gutter="[0, 6]">
                        <a-col :span="6">
                            <a-form-item label="申报年份">
                                <FGDictSelectCN dictNo="P0002" v-model="queryParams.sbnf" placeholder="" mode="multiple" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="评定日期从">
                                <a-date-picker v-model="queryParams.pdrq1" width="100%" valueFormat="YYYY-MM-DD" style="width:100%" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="到">
                                <a-date-picker v-model="queryParams.pdrq2" width="100%" valueFormat="YYYY-MM-DD" style="width:100%" />
                            </a-form-item>
                        </a-col>
                    </a-row>
                    <a-row :gutter="[0, 6]">
                        <a-col :span="6">
                            <a-form-item label="申报单位名称">
                                <a-input v-model="queryParams.sbdwmc" placeholder="" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="项目名称">
                                <a-input v-model="queryParams.xmmc" placeholder="" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="成果等级">
                                <FGDictSelectCN dictNo="JC1006" v-model="queryParams.cgdj" placeholder="" mode="multiple" />
                            </a-form-item>
                        </a-col>
                    </a-row>
                    <a-row :gutter="[0, 6]">
                        <a-col :span="24">
                            <span class="fun-search-form-buttons" :style="{ float: 'right', overflow: 'hidden' }">
                                <a-button type="primary" @click="loadData" style="margin-right: 8px">查询</a-button>
                                <a-button @click="reset">重置</a-button>
                                <!--<a
                                    style="marginLeft: 8px;fontSize: 12px"
                                    @click="
                                        () => {
                                            searchExpand = !searchExpand;
                                        }
                                    "
                                >
                                    {{ searchExpand ? "收起" : "展开" }} <a-icon :type="searchExpand ? 'up' : 'down'" />
                                </a>-->
                            </span>
                        </a-col>
                    </a-row>
                </a-form>
            </div>
        </a-anchor>
        <div class="fun-panel">
            <a-spin :spinning="tableDataLoading">
                <vxe-toolbar
                    size="mini"
                    custom
                    :refresh="{
                        query: () => {
                            this.loadData();
                        }
                    }"
                >
                    <template v-slot:buttons>
                        <a-button type="primary" @click="excelExport">导出Excel</a-button>
                    </template>
                </vxe-toolbar>

                <vxe-table
                    ref="table"
                    size="mini"
                    resizable
                    row-id="id"
                    auto-resize
                    align="left"
                    :max-height="tableHeight"
                    show-overflow="tooltip"
                    header-align="center"
                    :data="tableData"
                    highlight-hover-row
                    highlight-current-row
                    :sort-config="{
                        trigger: 'cell',
                        defaultSort: { field: sort.field, order: sort.order },
                        remote: true,
                        orders: ['asc', 'desc']
                    }"
                    @sort-change="handleSortChange"
                >
                    <vxe-table-column type="seq" title="序号" width="70" align="center"></vxe-table-column>
                    <vxe-table-column field="sbnf" title="申报年份" width="90" align="right" header-align="center" sortable></vxe-table-column>
                    <vxe-table-column field="cgdj" title="成果等级" width="90" align="right" header-align="center" sortable></vxe-table-column>
                    <vxe-table-column field="lxyy" title="落选原因" width="150" align="right" header-align="center"></vxe-table-column>
                    <vxe-table-column field="xmmc" title="项目名称" min-width="90" align="right" header-align="center" sortable></vxe-table-column>
                    <vxe-table-column field="sbdwmc" title="单位名称" min-width="120" align="right" header-align="center" sortable></vxe-table-column>
                    <vxe-table-column field="wcr" title="完成人" min-width="150" align="right" header-align="center" sortable></vxe-table-column>
                    <vxe-table-column field="pdrq" title="评定日期" width="100" align="right" header-align="center" sortable> </vxe-table-column>
                    <vxe-table-column title="操作" width="180" align="center">
                        <template v-slot="scope">
                            <span class="btn_edit" v-show="scope.row.cgdj != '不推荐'" @click="print(scope.row)">打印</span>
                        </template>
                    </vxe-table-column>
                </vxe-table>
                <vxe-pager
                    background
                    size="mini"
                    :current-page.sync="pageinfo.pageNo"
                    :page-size.sync="pageinfo.pageSize"
                    :total="pageinfo.total"
                    :layouts="['PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']"
                    @page-change="handlePageChange"
                >
                </vxe-pager>
            </a-spin>
        </div>
    </div>
</template>

<script>
export default {
    name: "CggscxBrowse",
    components: {},
    data() {
        return {
            tableData: [], //表格数据
            queryParams: {},
            // 分页
            pageinfo: {
                pageNo: 1,
                pageSize: 20,
                total: 0
            },
            // 排序
            sort: {
                field: "pdrq",
                order: "desc"
            },
            tableDataLoading: false,
            searchExpand: false,
            //设置默认最大高度
            tableHeight: 500
        };
    },
    computed: {
        // 是否显示编辑界面
        editIsVisible: {
            get() {
                return this.showEdit;
            },
            set(newVal) {
                this.$emit("update:showEdit", newVal);
            }
        },
        viewIsVisible: {
            get() {
                return this.showView;
            },
            set(newVal) {
                this.$emit("update:showView", newVal);
            }
        },
        // 当前编辑记录id
        editDataId: {
            get() {
                return this.dataId;
            },
            set(newVal) {
                this.$emit("update:dataId", newVal);
            }
        }
    },
    mounted() {
        //计算列表合适高度
        this.tableHeight = this.$FG_util.getTableHeight();
    },
    watch: {
        searchExpand(newValue) {
            //计算列表合适高度
            this.$nextTick(() => {
                this.tableHeight = this.$FG_util.getTableHeight();
            });
        }
    },
    activated() {
        this.loadData(this.editDataId);
    },
    methods: {
        //双击事件
        doubleClick({ row }) {
            this.view(row);
        },
        //点击页码
        handlePageChange({ currentPage, pageSize }) {
            this.pageinfo.pageNo = currentPage;
            this.pageinfo.pageSize = pageSize;
            this.loadData();
        },
        //点击表头排序
        handleSortChange({ property, order }) {
            this.sort.field = property;
            this.sort.order = order;
            this.loadData();
        },
        //查询列表数据
        loadData(id) {
            // 如果没有指定选中记录则选中刷新前选中的记录
            if (!id) {
                let row = this.$refs.table.getCurrentRecord();
                if (row) {
                    id = row.id;
                }
            }
            this.tableDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/zxcggl/cggsgl/listCGGS",
                    {
                        funid: "CG5002",
                        menuid: "FBBFD379-3F15-448B-B8C0-0E886ED1EE1F",
                        defaulttablename: "CG_CGPDB",
                        pageNo: this.pageinfo.pageNo,
                        pageSize: this.pageinfo.pageSize,
                        queryParams: this.queryParams,
                        sort: this.sort
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.tableDataLoading = false;
                    if (success) {
                        this.tableData = data.data;
                        // 需要设置当前页，因为查询可能导致当前页发生变化
                        this.pageinfo.pageNo = data.pageinfo.pagenum;
                        this.pageinfo.total = data.pageinfo.maxrow;
                    } else {
                        // 数据加载失败清空表格
                        this.tableData = [];
                    }
                })
                .then(() => {
                    this.$nextTick(() => {
                        let row = null;
                        // 获取之前选择的记录
                        if (id) {
                            row = this.$refs.table.getRowById(id);
                        }
                        // 如果之前没有选择记录且表格不为空则选择第一条记录
                        if (!row && this.tableData.length > 0) {
                            row = this.$refs.table.getRowById(this.tableData[0].id);
                        }
                        if (row) {
                            // 设置当前记录
                            this.$refs.table.setCurrentRow(row);
                        } else {
                            // 清空当前行
                            this.$refs.table.clearCurrentRow();
                        }
                    });
                });
        },
        //重置文本内容
        reset() {
            this.queryParams = {};
        },
        // 编辑
        edit(row) {
            // 设置编辑记录id
            this.editDataId = row.id;
            // 显示编辑界面
            this.editIsVisible = true;
        },
        print(row) {
            // 打印证书
            this.tableDataLoading = true;
            this.$FG_http
                .post(
                    "./api//main/zxcggl/cggsgl/reportZXCG",
                    {
                        dataId: row.id
                    },
                    {
                        responseType: "blob",
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.tableDataLoading = false;
                    if (success) {
                        let binaryData = [];
                        binaryData.push(data);
                        let url = window.URL.createObjectURL(new Blob(binaryData, { type: "application/pdf" }));
                        window.open(url);
                    } else {
                        this.$FG_message.error("P0002");
                    }
                });
        },
        excelExport() {
            let file_name = "成果评定结果查询" + this.$FG_util.formatDate(new Date());
            let template_name = "ZXCGGL\\CGGSGL\\CGGSCX";
            let config = {
                file_name: file_name,
                template_name: template_name,
                beanName: "CGGSServiceImpl",
                methodName: "listCGGS",
                funid: "CG5002",
                menuid: "FBBFD379-3F15-448B-B8C0-0E886ED1EE1F",
                defaulttablename: "CG_CGPDB",
                params: ["pageInfo", "orderby", "userInfo", this.queryParams, "funparams"]
            };
            this.$FG_blob.excelExport(config, this.sort);
        }
    }
};
</script>
